<script></script>

<section>
    <h3>Kontakt</h3>
    <p>
        adres: <a href="https://maps.app.goo.gl/m3pP4dGRBkcYV9rS7">
            ul. Żuławskiego 11/3 Kraków
        </a>
    </p>
    <p>(Okolice Nowego Kleparza)</p>
    <p><a href="tel:+48516427077">Telefon: 516427077</a></p>
</section>

<style>
    section {
        text-align: center;
        justify-content: center;
        align-items: center;
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 60vh;
        font-size: 2em;
    }

    p {
        font-size: 0.7em;
        width: 80%;
        color: #0b303b;
    }
</style>
